module.exports = __webpack_public_path__ + "img/invoices.2eaaafb2.jpg";